module.exports = __webpack_public_path__ + "img/1492174142.7494fbc0.jpg";